import { Component, OnInit, OnDestroy } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { LocalizationService } from 'src/app/core/helpers/localization.service';

@Component({
  selector: 'loyaltic-winners',
  templateUrl: './winners.component.html',
  styleUrls: ['./winners.component.scss']
})
export class WinnersComponent implements OnInit, OnDestroy {
  showSurveyScript = false;
  dailyWinners = [];
  weeklyWinners = [];
  showWinners = 'Weekly';

  constructor(private localizationService: LocalizationService,
    private cookie: CookieService, private coreService: CoreService) { }

  ngOnDestroy(): void {
  }

  ngOnInit() {
    // this.showSurvey();
    this.getWinners();
  }

  getWinners() {
    this.coreService.getWinners().then((response: any) => {
      this.dailyWinners = response.result.dailyWinners;
      this.weeklyWinners = response.result.weeklyWinners;
    });
  }

  showSurvey() {
    if (!this.cookie.check('showSurvey')) {
      this.cookie.set('showSurvey', 'showSurvey');
      this.cookie.delete('smcx_0_last_shown_at');
      this.showSurveyScript = true;
    }
  }

}
